import { ListChargerGroupsTariffsForExtendQuery, ListChargerGroupsForExtendQuery } from 'src/@types';

export const getTariffsForChargerGroup = (
  chargerGroupsWithTariffs: NonNullable<ListChargerGroupsTariffsForExtendQuery['listChargerGroups']>['edges'],
  chargerGroup: NonNullable<NonNullable<ListChargerGroupsForExtendQuery['listChargerGroups']>['edges']>['0'],
) => {
  return chargerGroupsWithTariffs.filter((group) => group.altId === chargerGroup.altId).map((group) => group.tariff)[0];
};
